export const excludeMenuList = ['online-course', 'website-setting', 'enquiry'];
export const gradeList = ['N', 'K1', 'K2', 'K3', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2', 'S3', 'S4', 'S5', 'S6'];
export const settingInterval = 30;